import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom }: Theme) => ({
  endAdornment: {
    position: 'absolute',
    right: 14,
  },
  hidden: {
    visibility: 'hidden',
  },
  chevron: {
    color: custom.grey[19],
    transition: 'all 300ms ease',
  },
  chevronUp: {
    transform: 'rotate(180deg)',
  },
}));
